// @mui
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
// assets

//hooks
import { OpenIcon } from "src/assets/icon/Open";
import FileUploadIllustration from "src/assets/illustrations/fileUploadIllustration";
import useLocales from "src/hooks/useLocales";

// ----------------------------------------------------------------------

interface BlockContentProps {
  fileName: string;
  fileMessage: string;
  error?: boolean;
  singleUpload?: boolean;
  file: any;
}

export default function DenseBlockContent({
  fileName,
  fileMessage,
  error,
  singleUpload,
  file,
}: BlockContentProps) {
  const { translate } = useLocales();

  return (
    <Stack
      spacing={0.5}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: "column", md: singleUpload ? "row" : "column" }}
      sx={{ width: 1, textAlign: { xs: "center", md: "left" } }}
    >
      {singleUpload ? (
        <></>
      ) : (
        <FileUploadIllustration
          height={49}
          width={56}
          color={error ? "error" : "primary"}
        />
      )}
      <Box sx={{ p: 0 }}>
        {fileName ? (
          <Typography variant="body2">
            {singleUpload
              ? `${fileName.slice(0, 20)}...${fileName.slice(-10)}`
              : fileName}
          </Typography>
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: error ? "error.dark" : "text.secondary",
              textAlign: "center",
            }}
          >
            {translate(
              fileMessage ??
                "Drop your files here or browse through your machine."
            )}
            &nbsp;
          </Typography>
        )}
      </Box>
      {singleUpload && file && typeof file === "string" && (
        <Tooltip title={translate("preview_file")} placement="top">
          <IconButton
            onClick={() => {
              window.open(file, "_blank");
            }}
            sx={{ p: 0 }}
          >
            <OpenIcon width={17} height={17} />
          </IconButton>
        </Tooltip>
      )}
    </Stack>
  );
}
